import { ImageModel } from '@/types';
import { createContext, ReactNode, useState } from 'react';

interface IMediaGalleryContext {
  selectedImage?: ImageModel;
  open: boolean;
  openMediaGallery: (image?: ImageModel) => void;
  closeMediaGallery: () => void;
  showGalleryButton: boolean;
  setShowGalleryButton: (value: boolean) => void;
}

export const MediaGalleryContext = createContext<IMediaGalleryContext>({
  open: false,
  openMediaGallery: () => {},
  closeMediaGallery: () => {},
  showGalleryButton: false,
  setShowGalleryButton: () => {},
});

export const MediaGalleryContextElement = ({ children }: { children: ReactNode | undefined }) => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<ImageModel>();
  const [showGalleryButton, setShowGalleryButton] = useState<boolean>(false);
  const openMediaGallery = (image?: ImageModel) => {
    setSelectedImage(image);
    setOpen(true);
  };
  const closeMediaGallery = () => {
    setSelectedImage(undefined);
    setOpen(false);
  };

  return (
    <MediaGalleryContext.Provider
      value={{ open, selectedImage, openMediaGallery, closeMediaGallery, showGalleryButton, setShowGalleryButton }}
    >
      {children}
    </MediaGalleryContext.Provider>
  );
};
